export default "__VITE_ASSET__B9NWG$P2__"